// src/component/groupActivity2026Format.js
//
// 「2026 グループ活動」関連の共通フォーマッタ。
//
// 期日（deadline）の保存形式：
//   - 新形式：`YYYY-MM-DDTHH:mm` または `YYYY-MM-DDTHH:mm:ss`（ローカル＝JST 入力）
//   - 旧形式：`YYYY-MM-DD`（その日の終わり 23:59:59 を期日とみなす）
//
// 「過ぎたかどうか」判定はサーバ時刻基準（serverNowMs）で行う。

import { serverNowMs } from "../api/serverTime";

/**
 * 期日文字列を Date に変換する。
 * - "YYYY-MM-DD" は当日の 23:59:59.999 ローカル時刻として扱う
 * - "YYYY-MM-DDTHH:mm" / "YYYY-MM-DDTHH:mm:ss" はそのままローカル時刻として扱う
 * 形式が壊れていれば null。
 */
function parseDeadline(deadline) {
  if (!deadline || typeof deadline !== "string") return null;

  // 日付のみ（旧形式）
  const dateOnly = deadline.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dateOnly) {
    const y = Number(dateOnly[1]);
    const m = Number(dateOnly[2]);
    const d = Number(dateOnly[3]);
    return { date: new Date(y, m - 1, d, 23, 59, 59, 999), hasTime: false };
  }

  // 日時（新形式：秒は任意）
  const dt = deadline.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/
  );
  if (dt) {
    const y = Number(dt[1]);
    const m = Number(dt[2]);
    const d = Number(dt[3]);
    const hh = Number(dt[4]);
    const mm = Number(dt[5]);
    const ss = dt[6] ? Number(dt[6]) : 0;
    return { date: new Date(y, m - 1, d, hh, mm, ss, 0), hasTime: true };
  }

  return null;
}

function pad2(n) {
  return n < 10 ? `0${n}` : `${n}`;
}

/**
 * 期日を表示用ラベルと「過ぎているか」フラグに変換する。
 * 値が無効／未設定なら null を返す。
 *
 * 過ぎた判定はサーバ時刻基準（事前に ensureServerTimeSynced() を呼んでおく）。
 */
export function formatDeadlineJa(deadline) {
  const parsed = parseDeadline(deadline);
  if (!parsed) return null;

  const { date, hasTime } = parsed;

  const weekDayJa = ["日", "月", "火", "水", "木", "金", "土"][date.getDay()];

  let label;
  if (hasTime) {
    label = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日（${weekDayJa}）${pad2(
      date.getHours()
    )}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())} まで`;
  } else {
    label = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日（${weekDayJa}）まで`;
  }

  const isPast = serverNowMs() > date.getTime();

  return { label, isPast, date };
}
